import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { listFolders, createFolder, moveToFolder } from '../services/foldersApi'
import type { Folder } from '../services/foldersApi'

/** List folders for the given actor */
export function useFolders(actorId?: string) {
  return useQuery<Folder[]>({
    queryKey: ['folders', actorId],
    queryFn: () => listFolders(actorId),
    enabled: !!actorId,
    staleTime: 60_000,
  })
}

/** Create a new folder */
export function useCreateFolder() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ name, parentId, actorId }: { name: string; parentId?: number; actorId?: string }) =>
      createFolder(name, parentId, actorId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['folders'] })
    },
  })
}

/** Move documents to a folder */
export function useMoveToFolder() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ folderId, documentIds, actorId }: { folderId: number; documentIds: string[]; actorId?: string }) =>
      moveToFolder(folderId, documentIds, actorId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['folders'] })
      queryClient.invalidateQueries({ queryKey: ['documents'] })
    },
  })
}
